export default {"src":"/_next/static/media/import-safe.0eb091a9.svg","height":64,"width":64};